export default __webpack_public_path__ + "static/media/Kanji.dbd68eac.png";